import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { FlatCharge } from '../../Models/Models/Charges/FlatCharge';

declare var IS_RUNNING_IN_APP_POOL;

export class FlatChargesClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(): Promise<Array<FlatCharge>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/charge/FlatCharges/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = {}

    return AjaxWrapper.get<Array<FlatCharge>, any>(url, data);
  }
}

